import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { ConfirmationDeleteTableDialog } from 'components/ui/feedback';
import { useTranslation } from 'react-i18next';

export function ContractLinesWarehouseColumns(
  handleManualDelete?: (id: number) => void
): GridColDef[] {
  const { t } = useTranslation();

  const columns: GridColDef[] | any[] = [
    { field: 'id', headerName: 'ID', flex: 1 },
    {
      field: 'code',
      headerName: t(`global.contract`),
      flex: 2
    },
    {
      field: 'supplier',
      headerName: t(`global.supplier`),
      flex: 3
    },
    {
      field: 'unit_price',
      headerName: t(`entities.contract_line.unit_price`),
      flex: 3
    },
    {
      field: 'initial_available_units',
      headerName: t(`entities.contract_line.initial_available_units`),
      flex: 4
    },
    {
      field: 'initial_discounted_units',
      headerName: t(`entities.contract_line.initial_discounted_units`),
      flex: 5
    },
    {
      field: 'iva',
      headerName: t(`entities.contract_line.iva`),
      flex: 4
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      renderCell: (params: GridRenderCellParams) => {
        return (
          <ConfirmationDeleteTableDialog
            key={995}
            id={+params.row.id}
            handleDelete={handleManualDelete}
          />
        );
      },
      filterable: false
    }
  ];

  return columns;
}
